import React from "react";
import { createUseStyles } from "react-jss";
import { variables } from "../../variables";

const DistributionSitesStyles = createUseStyles({
  DistributionSite: {
    display: "grid",
    overflow: "hidden",
    placeContent: "center",
  },
  title: {
    display: "grid",
    textAlign: "center",
    height: "100%",
    alignItems: "end",
    padding: variables.normal_gap,
  },
});
const DistributionSite = () => {
  const classes = DistributionSitesStyles();
  return (
    <div className={classes.DistributionSite}>
      <div className={classes.title}>
        <h1>Distribution Sites</h1>
      </div>
    </div>
  );
};

export default DistributionSite;
